import * as Sentry from '@sentry/browser';

(function () {
    var config = window.__SENTRY_CONFIG__;
    if (!config || !config.dsn) {
        return;
    }

    Sentry.init({
        dsn: config.dsn,
        environment: config.environment || 'development',
        tracesSampleRate: 0,
        beforeSend: function (event) {
            if (event.exception && event.exception.values) {
                var msg = event.exception.values[0].value || '';
                if (msg.match(/extensions\/|moz-extension:|chrome-extension:/i)) {
                    return null;
                }
            }
            return event;
        }
    });
})();
